import { updateBulkRepositoriesByFilter } from 'common/services/repositories.service';
import {
  GIT_PROVIDERS,
  REPOSITORIES_STATE,
  TRACKING
} from 'common/constants/constants';
import { createConfirmModalOptions } from 'modals/modal-options-factory';
import * as TrackingService from 'common/services/tracking.service';

const disconnectGitStreamForEntireSensorAuth = async sensorAuthorizationId => {
  await updateBulkRepositoriesByFilter(
    { sensor_authorization_id: sensorAuthorizationId },
    {
      extra: { is_gitstream_enabled: false }
    }
  );
};

export const updateActivationGitStreamForRepo = async (
  repository,
  newState,
  updateRepository,
  getSensorAuthorizations
) => {
  const {
    id,
    name,
    sensor_id: sensorId,
    sensor_authorization_id: sensorAuthorizationId
  } = repository;

  // this code relevant only for Gitlab gitStream Integration
  if (sensorId !== GIT_PROVIDERS.GITLAB) {
    return;
  }

  // this code is relevant only for removing repository and thus removing gitstream
  if (newState === REPOSITORIES_STATE.ACTIVE) {
    return;
  }

  // if we on Gitlab and the repository name is CM we should DISCONNECT GitStream
  if (isCmRepo(name) && newState === REPOSITORIES_STATE.INACTIVE) {
    if (repository.extra.is_gitstream_enabled === true) {
      await disconnectGitStreamForEntireSensorAuth(sensorAuthorizationId);
      await getSensorAuthorizations({ withGitStreamEnabled: true });
      return;
    }
  }

  await updateRepository(id, {
    extra: { is_gitstream_enabled: false }
  });
};

export const getDisableGitStreamConfirmationModalOptions = ({
  onCancel,
  onDisconnect
}) =>
  createConfirmModalOptions({
    width: '33rem',
    title: 'Are you sure?',
    description:
      'Disconnecting gitStream will halt automation rules, leading to potential disruptions in your development pipeline, impacting cycle time and efficiency',
    confirmText: 'Disconnect gitStream',
    cancelText: 'Cancel',
    onConfirm: onDisconnect,
    onCancel
  });

export const onDisconnectGitStream = async ({
  sensorAuthorizationId,
  toggleModal,
  getSensorAuthorizations,
  getRepositories,
  gitIntegration
}) => {
  await disconnectGitStreamForEntireSensorAuth(sensorAuthorizationId);
  await getSensorAuthorizations({ withGitStreamEnabled: true });
  await getRepositories();
  toggleModal();

  if (gitIntegration) {
    const { name, sensor_name: sensorName } = gitIntegration;

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.SETTINGS,
      page_tab: TRACKING.PAGE_TABS.GIT_INTEGRATIONS,
      integration_name: name,
      integration_type: sensorName,
      click_type: 'disconnect_gitstream'
    });
  }
};

export const isCmRepo = name =>
  name.toLowerCase().endsWith('/cm') || name.toLowerCase() === 'cm';
